const firebaseConfig = {
    apiKey: "AIzaSyBx9R99czuXGnMj8TeNQecn-WLCJXfZPe0",
    authDomain: "travel-guru-x.firebaseapp.com",
    databaseURL: "https://travel-guru-x.firebaseio.com",
    projectId: "travel-guru-x",
    storageBucket: "travel-guru-x.appspot.com",
    messagingSenderId: "517822692953",
    appId: "1:517822692953:web:db5e64b369bb47b302fb48"
  };

  export default firebaseConfig;